// Sentry initialization FIRST - before any other imports
import * as Sentry from "@sentry/react";

import envConfig from "@perfectserve/env-ps";

// eslint-disable-next-line no-console
console.info("env-ps config:", envConfig);

// Initialize Sentry immediately
const sentryDsn = envConfig.sentryDsn;
const environment = envConfig.environment;

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: environment || "development",
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    integrations: [
      Sentry.browserTracingIntegration({
        enableInp: false,
      }),
    ],
    beforeSend(event) {
      if (environment === "development") {
        return null; // Don't send errors in development
      }
      return event;
    },
  });
}

import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";

const container = document.getElementById("root");

// Only use Sentry error handlers if Sentry is initialized
const sentryHandlers = Sentry.getClient()
  ? {
      onUncaughtError: Sentry.reactErrorHandler(),
      onCaughtError: Sentry.reactErrorHandler(),
      onRecoverableError: Sentry.reactErrorHandler(),
    }
  : {};

const root = createRoot(container!, sentryHandlers);

root.render(<App />);
